import { Pipe, PipeTransform } from '@angular/core';
import { IGeoPositionRadiusInterface } from "./i-geo-position-radius.interface";

export enum EGeopositionUnit {
    m = 'm',
    km = 'km',
}

@Pipe({
    name: 'radius'
})
export class RadiusPipe implements PipeTransform {

    private units: typeof EGeopositionUnit = EGeopositionUnit;

    public transform(value: IGeoPositionRadiusInterface): string {

        const max: number = typeof value.max === 'number' ?
            Number((value.max as number).toFixed(0)) :
            Number((value.max as string).split('.')[0]);

        return `${max} ${this.units[value.unit]}`;

    }
}
